import { Page } from '@/core/architecture'

import { PushNotificationSettingsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * PushNotificationSettings Page
 * Implemented as a practical sample.
 */
export const PushNotificationSettings: Page = () => {
  const { state, actions } = useViewModel()

  return <PushNotificationSettingsTemplate state={state} {...actions} />
}
